// /api/common/v1/reoprt/pdfVerify
export const pdfVerifyAddressPath = "http://49.4.7.22:8069/restful/api/common/v1/reoprt/pdfVerify"